export const coachingSessionTypes = {
  SMP_SESSION: 'smp_session',
  INTL_SMP_SESSION: 'intl_smp_session',
  SSC_SESSION: 'ssc_session',
  COACHING_FOR_PARENTS_SESSION: 'coaching_for_parents_session',
}

// Session types for LT providers
export const LTsessionTypes = {
  AUD_SESSION: 'alcohol_use_disorder_session',
  BCT_SESSION: 'lyra_therapy_session',
  DBT_SESSION: 'dbt_session',
  DBT_GROUP_SESSION: 'dbt_group_session',
  LCTT_SESSION: 'lyra_therapy_teens_session',
  INITIAL_MEDS_SESSION: 'lyra_therapy_meds_initial_session',
  FOLLOWUP_MEDS_SESSION: 'lyra_therapy_meds_follow_up_session',
  INITIAL_CLE_SESSION: 'clinical_leave_evaluation_initial_session',
  FOLLOWUP_CLE_SESSION: 'clinical_leave_evaluation_follow_up_session',
  INITIAL_DA_SESSION: 'individual_initial_evaluation',
  INITIAL_DA_CHILD_SESSION: 'child_initial_evaluation',
  FOLLOWUP_DA_SESSION: 'individual_follow_up_session',
  FOLLOWUP_DA_CHILD_SESSION: 'child_follow_up_session',
  INITIAL_DA_COUPLES_SESSION: 'couples_initial_evaluation',
  FOLLOWUP_DA_COUPLES_SESSION: 'couples_follow_up_session',
  INITIAL_DA_FAMILY_SESSION: 'family_initial_evaluation',
  FOLLOWUP_DA_FAMILY_SESSION: 'family_follow_up_session',

  ...coachingSessionTypes,
}
